module.exports = __webpack_public_path__ + "static/media/freetag.b62e12ce.jpg";